import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ClubService } from "../../providers/club.service";
import { BvDialogService, BvDialogRef } from "../../design-system";
import { BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent } from "../../design-system/primitives/dialog.component";
import { BvButtonComponent } from "../../design-system/primitives/button.component";
import { TranslateModule } from "@ngx-translate/core";
@Component({
    selector: "app-max-players",
    templateUrl: "./max-players.component.html",
    styleUrls: ["./max-players.component.css"],
    imports: [BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent, BvButtonComponent, TranslateModule]
})
export class MaxPlayersComponent implements OnInit {
  constructor(
    public clubServ: ClubService,
    private router: Router,
    private dialog: BvDialogService,
    public dialogRef: BvDialogRef<MaxPlayersComponent>
  ) {}

  ngOnInit() {}
  goSubscription() {
    this.dialog.closeAll();
    this.router.navigate(["/subscription"], {
      queryParams: { source: "lock_player_limit" },
    });
  }
}
